import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { ApiResponse } from '../api-response.model';
import { EducationDto } from '../fn/generals/education.model';

@Injectable({
  providedIn: 'root',
})
export class EducationService {
  constructor(private http: HttpClient, private config: ApiConfiguration) {}

  getEducations(): Observable<ApiResponse<{educations: EducationDto[]}>> {
    const url = `${this.config.rootUrl}/grado-educacion/activos`;
    return this.http.get<ApiResponse<{educations: EducationDto[]}>>(url);
  }
}
